module.exports = __webpack_public_path__ + "981378cd3cac41fc515a463eaca64e3d.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_r_60.mp3
// module id = 419
// module chunks = 0